import styled from "styled-components";

const ToolbarContainer = styled.nav`
    width: 100%;
    min-height: 64px;
    position: absolute; //relative to StyledDesktop
    bottom: 0px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
`

export default ToolbarContainer;